<template lang="pug">

    .ui.red.small.pointing.label(v-show='isVisible' v-if="!hideMessage") {{ message }}

</template>

<script>

    // noinspection ReservedWordAsName
    export default {

        computed: {

            isVisible() {
                return this.validation.hasError(this.attribute)
            },

            message() {
                return this.validation.firstError(this.attribute)
            }

        },

        props: {

            attribute: {
                type: String,
                required: true,
            },

            hideMessage: {
                type: Boolean,
                default: false
            },

            validation: {
                type: Object,
                required: true
            },

        },

        watch: {

            isVisible(isVisible) {
                const fieldEl = $(this.$el).closest('.field')

                if (isVisible === true) {
                    fieldEl.addClass('error')
                } else {
                    fieldEl.removeClass('error')
                }
            }

        }

    }

</script>
